import cn from 'classnames';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import SignIn from 'components/candidate/SignIn';
import Logo from 'components/Logo';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './Signup.module.scss';

const Signup = (): ReactElement => {
  const router = useRouter();

  const onSignInComplete = async (onboardingCompleted?: boolean) => {
    if (onboardingCompleted) {
      const pathname = `${PAGE_ROUTES.CANDIDATE_PROFILE}`;
      router.replace(pathname);
    } else {
      const pathname = `${PAGE_ROUTES.AI_ONBOARDING}`;
      router.replace(pathname);
    }
  };

  return (
    <>
      <Head>
        <title>Generate CVs, Cover Letters & Fill Applications | Huzzle</title>
        <meta
          name="description"
          content="Automatically Generate CVs, Cover Letters & Fill Applications in seconds with Huzzle, the largest early careers network for students."
        />
      </Head>

      <section className={styles.container} data-testid="Signin">
        <Logo
          name="huzzle-new"
          size="small"
          color="primary"
          className={cn(styles.logo, styles.hideMobile)}
        />
        <SignIn
          onComplete={onSignInComplete}
          className={styles.Signup}
          isLoginPopup={false}
        />
      </section>
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, 'common')),
    },
  };
}

export default Signup;
